import { AccessControlListService } from '@era/security-sdk';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { UserGroupAclEffects } from './user-group-acl.effects';
import { userGroupAclReducer } from './user-group-acl.reducer';

export const provideUserGroupAclStore = () => [
  provideState('userGroupAcls', userGroupAclReducer),
  provideEffects([UserGroupAclEffects]),
  AccessControlListService,
];
